import { generatePath } from 'react-router-dom'
import { LEARNING_LOOP_PLAYGROUND_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { ArrowRefresh2 } from 'blaze-ui/icons/20/ArrowRefresh2'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuLearningLoopPlaygroundItem = ({ workspaceId, onPress }: Props) => {
  return (
    <NavMenuItem
      icon={ArrowRefresh2}
      activeIcon={ArrowRefresh2}
      to={generatePath(LEARNING_LOOP_PLAYGROUND_PATH, { workspaceId })}
      onPress={onPress}
      label="Learnings Playground"
    />
  )
}

export { NavMenuLearningLoopPlaygroundItem }
